import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../../api/rbacApi";

export const fetchPermissions = createAsyncThunk(
  "permission/fetchPermissions",
  async (_, { rejectWithValue }) => {
    try {
      const res = await api.get("/api/admin/rbac/permissions");
      return res.data || [];
    } catch (err) {
      return rejectWithValue(err.response?.data || "Failed to fetch permissions");
    }
  }
);

const permissionSlice = createSlice({
  name: "permission",
  initialState: {
    permissions: [],
    loading: false,
    error: null,
  },
  reducers: {},

  extraReducers: (builder) => {
    builder
      .addCase(fetchPermissions.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchPermissions.fulfilled, (state, action) => {
        state.loading = false;
        state.permissions = action.payload;
      })
      .addCase(fetchPermissions.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default permissionSlice.reducer;